import {autobind} from 'core-decorators';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars


export class Tooltip extends Component<jsx.Props, jsx.State> {
    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.state = {
            showToolTip: false,
        };
        if (props.addTooltipActivationCallback) {
            props.addTooltipActivationCallback(this.activate);
        }
        if (props.addTooltipDeactivationCallback) {
            props.addTooltipDeactivationCallback(this.deactivate);
        }
    }
    @autobind
    activate() {
        this.setState({showToolTip: true});
        if (!this.props.addTooltipDeactivationCallback) {
            setTimeout(() => {
                this.deactivate();
            }, 1000);
        }
    }
    @autobind
    deactivate() {
        this.setState({showToolTip: false});
    }

    render() {
        const {showToolTip} = this.state;
        const {children, msg, hoverMsg} = this.props;
        let content;

        if (children) {
            content = children;
        } else if (showToolTip && msg) {
            content = msg;
        } else if (hoverMsg) {
            content = hoverMsg;
        } else {
            return null;
        }

        return (
            <div
                className={
                    `Tooltip${this.props.hasCallout ? ' hasCallout' : ''}`}
                style={{display: showToolTip ? 'block' : undefined}}
            >
                <span className="content">
                    { content }
                </span>
            </div>
        );
    }
}

export class TooltipWrapper extends Component<jsx.Props, jsx.State> {
    tooltipOffsetPct: number;
    tooltip: HTMLElement|null;

    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.tooltipOffsetPct = .5;
        this.tooltip = null;
        this.state = {
            showToolTip: false,
            left: `-${this.tooltipOffsetPct * 100}%`,
        };
        if (props.addTooltipActivationCallback) {
            props.addTooltipActivationCallback(this.activate);
        }
    }
    @autobind
    activate() {
        this.setState({showToolTip: true});

        setTimeout(() => {
            this.setState({showToolTip: false});
        }, 1000);
    }
    @autobind
    setElement(el: HTMLElement|null) {
        this.tooltip = el;
    }

    @autobind
    onMouseOver() {
        if (!this.tooltip) {
            return;
        }
        const windowWidth = window.innerWidth;
        const padding = 20;
        const {left, right, width} = this.tooltip.getBoundingClientRect();
        const rightMarginOverlap =
            right - (width * this.tooltipOffsetPct) - windowWidth + padding;
        const leftMarginOverlap =
            (width * this.tooltipOffsetPct) - left + padding;

        // NOTE: ensures that tooltip does not overflow over edge of page
        if (rightMarginOverlap > 0) {
            const leftOffset =
                -(rightMarginOverlap + (width * this.tooltipOffsetPct));
            this.setState({left: leftOffset});
        } else if (leftMarginOverlap > 0) {
            const leftOffset =
                -((width * this.tooltipOffsetPct) - leftMarginOverlap);
            this.setState({left: leftOffset});
        }
    }

    @autobind
    onMouseLeave() {
        this.setState({left: `-${this.tooltipOffsetPct * 100}%`});
    }

    render() {
        const {showToolTip} = this.state;
        const {children, tooltipMsg, size} = this.props;

        return (
            <span
                className='TooltipWrapper'
                onMouseOver={this.onMouseOver}
                onMouseLeave={this.onMouseLeave}
                onTouchStart={() => {}} // HACK: iOS css "hover" trigger
            >
                <div
                    className={`TooltipV2 ${size}`}
                    style={{
                        display: showToolTip ? 'block' : undefined,
                    }}
                    ref={this.setElement}
                >
                    <span
                        className="content"
                        style={{
                            left: this.state.left,
                        }}
                    >
                        { tooltipMsg }
                    </span>
                </div>
                {children}
            </span>
        );
    }
}
